<template>
  <v-container fluid class="fill-height background-gradient pa-2 pa-sm-3">
    <v-row align="start" justify="center">
      <v-col cols="12" sm="11" md="10" lg="9" class="pa-1 pa-sm-3">
        <!-- Cabeçalho -->
        <v-card elevation="6" class="page-card mb-3 mb-sm-4" rounded="lg">
          <v-card-title class="d-flex justify-space-between align-center py-3 px-3 px-sm-4">
            <span class="text-h6 text-sm-h5 text-md-h4 font-weight-medium primary--text">
              <v-icon left :size="$vuetify.breakpoint.smAndUp ? 26 : 20" color="primary">mdi-school</v-icon>
              <span class="d-none d-sm-inline">Controle de Estudos</span>
              <span class="d-sm-none">Estudos</span>
            </span>
            <v-chip
                v-if="sessaoAtiva"
                color="success"
                :small="$vuetify.breakpoint.xs"
                class="px-2 px-sm-4"
            >
              <v-icon left :small="$vuetify.breakpoint.xs">mdi-clock-check</v-icon>
              <span class="d-none d-sm-inline">Sessão Ativa</span>
              <span class="d-sm-none">Ativa</span>
            </v-chip>
          </v-card-title>
        </v-card>

        <!-- Tabs -->
        <v-card elevation="6" class="page-card estudo-tabs-card" rounded="lg">
          <v-tabs
              v-model="tabAtiva"
              background-color="primary"
              dark
              grow
              slider-color="secondary"
              :height="$vuetify.breakpoint.xs ? 48 : 64"
              show-arrows
              class="study-tabs"
          >
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-clock</v-icon>
              <span class="d-none d-sm-inline">Controle</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-bookshelf</v-icon>
              <span class="d-none d-sm-inline">Temas</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-chart-line</v-icon>
              <span class="d-none d-sm-inline">Progresso</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-history</v-icon>
              <span class="d-none d-sm-inline">Histórico</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-cards</v-icon>
              <span class="d-none d-sm-inline">Flashcards</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-trophy</v-icon>
              <span class="d-none d-sm-inline">Mimos da Lau</span>
            </v-tab>
            <v-tab class="tab-item">
              <v-icon :small="$vuetify.breakpoint.xs" :left="$vuetify.breakpoint.smAndUp">mdi-checkbox-marked-circle-outline</v-icon>
              <span class="d-none d-sm-inline">LauChecks</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items
              v-model="tabAtiva"
              :transition="tabsItemsTransition"
              :reverse-transition="tabsItemsTransition"
              :touchless="isMobileViewport"
          >
            <!-- TAB 1: CONTROLE DE ESTUDO -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <v-card-text class="pa-3 pa-sm-6">
                <v-row>
                  <!-- Sessão Ativa ou Nova Sessão -->
                  <v-col cols="12" lg="6" class="mb-3 mb-sm-4">
                    <!-- Sessão Ativa -->
                    <v-card v-if="sessaoAtiva" elevation="4" rounded="lg" outlined class="sessao-card">
                      <v-card-title :style="{ backgroundColor: sessaoAtiva.temaCorHex }" class="white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white" :size="$vuetify.breakpoint.smAndUp ? 26 : 20">mdi-clock-check</v-icon>
                        <span class="text-body-1 text-sm-h5">Sessão em Andamento</span>
                      </v-card-title>
                      <v-card-text class="pa-3 pa-sm-6 text-center">
                        <div class="text-h6 text-sm-h5 text-md-h4 mb-3 mb-sm-4 font-weight-medium">{{ sessaoAtiva.temaNome }}</div>

                        <!-- Cronômetro Regressivo -->
                        <div class="mb-4 mb-sm-5">
                          <div class="text-caption grey--text mb-1">Tempo Restante da Meta Semanal</div>
                          <div class="cronometro-display font-weight-bold primary--text mb-2">
                            {{ tempoFormatado }}
                          </div>
                          <div class="text-body-2 grey--text">
                            Estudado hoje: {{ tempoSessaoVisual }}
                          </div>
                        </div>

                        <v-row dense class="mb-3 mb-sm-4">
                          <v-col cols="6" v-if="sessaoAtiva.status === 'EM_ANDAMENTO'">
                            <v-btn
                                block
                                :large="$vuetify.breakpoint.smAndUp"
                                color="warning"
                                @click="pausarSessao"
                                :loading="carregandoSessao"
                                class="py-3 py-sm-4"
                            >
                              <v-icon left>mdi-pause</v-icon>
                              Pausar
                            </v-btn>
                          </v-col>
                          <v-col cols="6" v-if="sessaoAtiva.status === 'PAUSADA'">
                            <v-btn
                                block
                                :large="$vuetify.breakpoint.smAndUp"
                                color="success"
                                @click="retomarSessao"
                                :loading="carregandoSessao"
                                class="py-3 py-sm-4"
                            >
                              <v-icon left>mdi-play</v-icon>
                              Retomar
                            </v-btn>
                          </v-col>
                          <v-col :cols="6">
                            <v-btn
                                block
                                :large="$vuetify.breakpoint.smAndUp"
                                color="error"
                                @click="finalizarSessao"
                                :loading="carregandoSessao"
                                class="py-3 py-sm-4"
                            >
                              <v-icon left>mdi-stop</v-icon>
                              Finalizar
                            </v-btn>
                          </v-col>
                        </v-row>

                        <v-chip
                            v-if="sessaoAtiva.status === 'PAUSADA'"
                            color="warning"
                            :large="$vuetify.breakpoint.smAndUp"
                            class="mt-3"
                        >
                          <v-icon left>mdi-pause-circle</v-icon>
                          PAUSADO
                        </v-chip>

                        <v-btn
                            v-if="sessaoAtiva.status === 'PAUSADA'"
                            block
                            outlined
                            color="grey"
                            @click="confirmarCancelarSessao"
                            :loading="carregandoSessao"
                            class="mt-3"
                        >
                          <v-icon left>mdi-close-circle</v-icon>
                          Cancelar Sessão
                        </v-btn>

                        <div v-if="sessaoAtiva.observacao" class="mt-4 mt-sm-6">
                          <v-divider class="mb-3 mb-sm-4"></v-divider>
                          <div class="text-subtitle-2 text-sm-subtitle-1 grey--text text--darken-1 mb-2">Observação:</div>
                          <div class="text-body-2 text-sm-body-1">{{ sessaoAtiva.observacao }}</div>
                        </div>
                      </v-card-text>
                    </v-card>

                    <!-- Iniciar Nova Sessão -->
                    <v-card v-else elevation="4" rounded="lg" outlined class="sessao-card">
                      <v-card-title class="success white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white" :size="$vuetify.breakpoint.smAndUp ? 28 : 22">mdi-play-circle</v-icon>
                        <span class="text-body-1 text-sm-h5">Iniciar Nova Sessão</span>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                color="white"
                                v-bind="attrs"
                                v-on="on"
                                @click="dialogSessaoManual = true"
                            >
                              <v-icon>mdi-pencil-plus</v-icon>
                            </v-btn>
                          </template>
                          <span>Registrar Sessão Manual</span>
                        </v-tooltip>
                      </v-card-title>
                      <v-card-text class="pa-3 pa-sm-6">
                        <v-form ref="formSessao" v-model="formSessaoValido">
                          <v-select
                              v-model="novaSessao.temaEstudoId"
                              :items="temasAtivos"
                              item-text="nome"
                              item-value="id"
                              label="Selecione o Tema"
                              outlined
                              prepend-inner-icon="mdi-book"
                              :rules="[v => !!v || 'Tema é obrigatório']"
                              required
                              class="mb-3"
                              :dense="$vuetify.breakpoint.xs"
                          >
                            <template v-slot:item="{ item }">
                              <v-list-item-avatar>
                                <v-avatar :color="item.corHex" size="40">
                                  <v-icon color="white">mdi-book</v-icon>
                                </v-avatar>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.nome }}</v-list-item-title>
                                <v-list-item-subtitle>Meta: {{ formatarTempoMeta(item) }}/semana</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-select>

                          <v-textarea
                              v-model="novaSessao.observacao"
                              label="Observação (opcional)"
                              outlined
                              :rows="$vuetify.breakpoint.xs ? 2 : 3"
                              prepend-inner-icon="mdi-note-text"
                              class="mb-3"
                              :dense="$vuetify.breakpoint.xs"
                          ></v-textarea>

                          <v-btn
                              block
                              :large="$vuetify.breakpoint.smAndUp"
                              color="success"
                              @click="iniciarSessao"
                              :loading="carregandoSessao"
                              :disabled="!formSessaoValido || !novaSessao.temaEstudoId"
                              class="py-3 py-sm-4"
                          >
                            <v-icon left>mdi-play</v-icon>
                            Iniciar Sessão
                          </v-btn>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Sala de Estudos / Temas Disponíveis -->
                  <v-col cols="12" lg="6" class="mb-3 mb-sm-4">
                    <SalaEstudos v-if="sessaoAtiva" ref="salaEstudos" />

                    <div v-else>
                      <v-card elevation="4" rounded="lg" outlined>
                        <v-card-title class="primary white--text py-3 py-sm-4 px-3 px-sm-4">
                          <v-icon left color="white" size="22">mdi-bookshelf</v-icon>
                          <span class="text-body-1 text-sm-h5">Temas Disponíveis</span>
                        </v-card-title>
                        <v-card-text class="pa-2 pa-sm-4" style="max-height: 400px; overflow-y: auto;">
                          <v-list v-if="temasAtivos.length > 0" class="pa-0">
                            <v-list-item
                                v-for="tema in temasAtivos"
                                :key="tema.id"
                                @click="selecionarTemaControle(tema)"
                                class="mb-2 rounded tema-item"
                                :class="$vuetify.breakpoint.xs ? 'px-2' : ''"
                                two-line
                            >
                              <v-list-item-avatar :size="$vuetify.breakpoint.xs ? 36 : 48">
                                <v-avatar :color="tema.corHex" :size="$vuetify.breakpoint.xs ? 36 : 48">
                                  <v-icon color="white" :size="$vuetify.breakpoint.xs ? 20 : 28">mdi-book</v-icon>
                                </v-avatar>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold text-body-2 text-sm-body-1 mb-1">
                                  {{ tema.nome }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="text-caption text-sm-body-2">
                                  Meta: {{ formatarTempoMeta(tema) }}/semana
                                </v-list-item-subtitle>
                              </v-list-item-content>

                              <v-list-item-action>
                                <v-chip :color="tema.corHex" dark :small="$vuetify.breakpoint.xs">
                                  <span class="font-weight-bold">{{ calcularProgressoTema(tema.id) }}%</span>
                                </v-chip>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                          <v-alert v-else type="info" prominent class="ma-2">
                            <div class="text-body-2 font-weight-medium">Nenhum tema cadastrado ainda.</div>
                            <div class="text-caption mt-1">Vá para a aba "Temas" para criar seu primeiro tema.</div>
                          </v-alert>
                        </v-card-text>
                      </v-card>

                      <!-- Indicador de Sala de Estudos -->
                      <v-card elevation="2" rounded="lg" outlined class="mt-2 mt-sm-3">
                        <v-card-text class="py-3 px-3 px-sm-4">
                          <div v-if="infoSalaEstudos" class="d-flex align-center justify-space-between">
                            <div class="d-flex align-center">
                              <v-icon :color="infoSalaEstudos.totalUsuariosEstudando > 0 ? 'success' : 'grey'" class="mr-2" small>
                                mdi-account-group
                              </v-icon>
                              <span class="text-caption text-sm-body-2 font-weight-medium">
                                {{ infoSalaEstudos.totalUsuariosEstudando > 0
                                  ? `${infoSalaEstudos.totalUsuariosEstudando} ${infoSalaEstudos.totalUsuariosEstudando === 1 ? 'pessoa estudando' : 'pessoas estudando'} agora`
                                  : 'Ninguém estudando no momento' }}
                              </span>
                            </div>
                            <v-chip
                                v-if="infoSalaEstudos.totalUsuariosEstudando > 0"
                                x-small
                                :color="infoSalaEstudos.totalUsuariosEstudando > 0 ? 'success' : 'grey'"
                                dark
                            >
                              <v-icon x-small left>mdi-fire</v-icon>
                              {{ infoSalaEstudos.totalUsuariosEstudando }}
                            </v-chip>
                          </div>
                          <div v-else class="d-flex align-center">
                            <v-progress-circular indeterminate size="16" width="2" color="grey" class="mr-2"></v-progress-circular>
                            <span class="text-caption grey--text">Carregando...</span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

            <!-- TAB 2: GERENCIAR TEMAS -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <v-card-text class="pa-3 pa-sm-6">
                <v-row>
                  <!-- Criar/Editar Tema -->
                  <v-col cols="12" md="6" class="mb-3 mb-sm-4">
                    <v-card elevation="4" rounded="lg" outlined>
                      <v-card-title class="primary white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white">{{ temaEditando ? 'mdi-pencil' : 'mdi-book-plus' }}</v-icon>
                        <span class="text-body-1 text-sm-h6">{{ temaEditando ? 'Editar Tema' : 'Novo Tema' }}</span>
                      </v-card-title>
                      <v-card-text class="pa-3 pa-sm-6">
                        <v-form ref="formTema" v-model="formTemaValido">
                          <v-text-field
                              v-model="temaAtual.nome"
                              label="Nome do Tema"
                              outlined
                              prepend-inner-icon="mdi-book"
                              :rules="[v => !!v || 'Nome é obrigatório']"
                              required
                              class="mb-3"
                              :dense="$vuetify.breakpoint.xs"
                          ></v-text-field>

                          <v-textarea
                              v-model="temaAtual.descricao"
                              label="Descrição (opcional)"
                              outlined
                              :rows="$vuetify.breakpoint.xs ? 2 : 3"
                              prepend-inner-icon="mdi-text"
                              class="mb-3"
                              :dense="$vuetify.breakpoint.xs"
                          ></v-textarea>

                          <v-row dense>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                  v-model.number="temaAtual.horas"
                                  label="Horas/Semana"
                                  outlined
                                  type="number"
                                  min="0"
                                  step="1"
                                  prepend-inner-icon="mdi-clock-outline"
                                  :rules="[v => v >= 0 || 'Horas não pode ser negativo']"
                                  required
                                  class="mb-3"
                                  @input="garantirInteiroHoras"
                                  :dense="$vuetify.breakpoint.xs"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-text-field
                                  v-model.number="temaAtual.minutos"
                                  label="Minutos/Semana"
                                  outlined
                                  type="number"
                                  min="0"
                                  max="59"
                                  step="1"
                                  prepend-inner-icon="mdi-timer-outline"
                                  :rules="[
                                    v => v >= 0 || 'Minutos não pode ser negativo',
                                    v => v <= 59 || 'Minutos deve ser menor que 60'
                                  ]"
                                  required
                                  class="mb-3"
                                  @input="garantirInteiroMinutos"
                                  :dense="$vuetify.breakpoint.xs"
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-alert
                              v-if="temaAtual.horas === 0 && temaAtual.minutos === 0"
                              type="warning"
                              dense
                              text
                              class="mb-3"
                          >
                            A meta semanal deve ser maior que 0
                          </v-alert>

                          <v-alert
                              v-else
                              type="info"
                              dense
                              text
                              class="mb-3"
                          >
                            Meta semanal: {{ formatarTempoTotal(temaAtual.horas, temaAtual.minutos) }}
                          </v-alert>

                          <v-text-field
                              v-model="temaAtual.corHex"
                              label="Cor"
                              outlined
                              prepend-inner-icon="mdi-palette"
                              type="color"
                              :rules="[v => !!v || 'Cor é obrigatória']"
                              required
                              class="mb-4"
                              :dense="$vuetify.breakpoint.xs"
                          ></v-text-field>

                          <v-btn
                              block
                              :large="$vuetify.breakpoint.smAndUp"
                              :color="temaEditando ? 'warning' : 'primary'"
                              @click="temaEditando ? salvarEdicaoTema() : criarTema()"
                              :loading="carregandoTema"
                              :disabled="!temaAtual.nome || (temaAtual.horas === 0 && temaAtual.minutos === 0)"
                              class="mb-2"
                          >
                            <v-icon left>{{ temaEditando ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                            {{ temaEditando ? 'Salvar Alterações' : 'Criar Tema' }}
                          </v-btn>

                          <v-btn
                              v-if="temaEditando"
                              block
                              text
                              @click="cancelarEdicao"
                          >
                            Cancelar Edição
                          </v-btn>
                        </v-form>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Lista de Temas -->
                  <v-col cols="12" md="6" class="mb-3 mb-sm-4">
                    <v-card elevation="4" rounded="lg" outlined>
                      <v-card-title class="primary white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white">mdi-bookshelf</v-icon>
                        <span class="text-body-1 text-sm-h6">Meus Temas</span>
                      </v-card-title>
                      <v-card-text class="pa-2 pa-sm-4" style="max-height: 450px; overflow-y: auto;">
                        <v-list v-if="temas.length > 0" class="pa-0">
                          <v-list-item
                              v-for="tema in temasOrdenados"
                              :key="tema.id"
                              @click="iniciarEdicaoTema(tema)"
                              class="mb-2 rounded tema-item"
                              two-line
                          >
                            <v-list-item-avatar :size="$vuetify.breakpoint.xs ? 34 : 40">
                              <v-avatar :color="tema.corHex" :size="$vuetify.breakpoint.xs ? 34 : 40">
                                <v-icon color="white" :small="$vuetify.breakpoint.xs">mdi-book</v-icon>
                              </v-avatar>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium text-body-2 text-sm-body-1">
                                {{ tema.nome }}
                                <v-chip v-if="!tema.ativo" x-small color="grey" dark class="ml-1">
                                  Inativo
                                </v-chip>
                              </v-list-item-title>
                              <v-list-item-subtitle class="text-caption">
                                Meta: {{ formatarTempoMeta(tema) }}/semana
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                      icon
                                      v-bind="attrs"
                                      v-on="on"
                                      @click.stop
                                      :small="$vuetify.breakpoint.xs"
                                  >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                  </v-btn>
                                </template>
                                <v-list dense>
                                  <v-list-item @click="iniciarEdicaoTema(tema)">
                                    <v-list-item-icon>
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>Editar</v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="tema.ativo ? desativarTema(tema) : ativarTema(tema)">
                                    <v-list-item-icon>
                                      <v-icon :color="tema.ativo ? 'warning' : 'success'">
                                        {{ tema.ativo ? 'mdi-eye-off' : 'mdi-eye' }}
                                      </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title :class="tema.ativo ? 'warning--text' : 'success--text'">
                                      {{ tema.ativo ? 'Desativar' : 'Ativar' }}
                                    </v-list-item-title>
                                  </v-list-item>
                                  <v-list-item @click="confirmarDeletarTema(tema)">
                                    <v-list-item-icon>
                                      <v-icon color="error">mdi-delete</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title class="error--text">Deletar</v-list-item-title>
                                  </v-list-item>
                                </v-list>
                              </v-menu>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                        <v-alert v-else type="info" text class="ma-2">
                          Nenhum tema cadastrado ainda.
                        </v-alert>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

            <!-- TAB 3: PROGRESSO -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <v-card-text class="pa-3 pa-sm-6">
                <v-row>
                  <!-- Progresso Semanal -->
                  <v-col cols="12" md="8" class="mb-3 mb-sm-4">
                    <v-card elevation="4" rounded="lg" outlined>
                      <v-card-title class="primary white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white">mdi-chart-line</v-icon>
                        <span class="text-body-1 text-sm-h6">Progresso Semanal</span>
                        <v-spacer></v-spacer>
                        <v-btn icon color="white" @click="carregarProgressoSemanal" :loading="carregandoProgresso" :small="$vuetify.breakpoint.xs">
                          <v-icon>mdi-refresh</v-icon>
                        </v-btn>
                      </v-card-title>

                      <!-- Navegação de Semana -->
                      <v-card-text class="pa-3 pa-sm-4 pb-0">
                        <v-row align="center" class="mb-2">
                          <v-col cols="12" class="d-flex align-center justify-space-between">
                            <v-btn
                                icon
                                @click="semanaAnterior"
                                :disabled="carregandoProgresso"
                                :small="$vuetify.breakpoint.xs"
                            >
                              <v-icon>mdi-chevron-left</v-icon>
                            </v-btn>

                            <div class="text-center">
                              <div class="text-body-2 text-sm-h6 font-weight-medium">{{ periodoSemanaFormatado }}</div>
                              <v-chip v-if="ehSemanaAtual" x-small color="success" class="mt-1">
                                Semana Atual
                              </v-chip>
                              <v-btn
                                  v-else
                                  x-small
                                  text
                                  color="primary"
                                  @click="voltarParaSemanaAtual"
                                  class="mt-1"
                              >
                                <v-icon small left>mdi-calendar-today</v-icon>
                                Voltar para hoje
                              </v-btn>
                            </div>

                            <v-btn
                                icon
                                @click="proximaSemana"
                                :disabled="carregandoProgresso || ehSemanaAtual"
                                :small="$vuetify.breakpoint.xs"
                            >
                              <v-icon>mdi-chevron-right</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>
                      </v-card-text>

                      <v-card-text class="pa-3 pa-sm-6">
                        <v-progress-linear
                            v-if="carregandoProgresso"
                            indeterminate
                            color="primary"
                            class="mb-4"
                        ></v-progress-linear>

                        <v-list v-if="progressoSemanal.length > 0" class="pa-0">
                          <v-list-item
                              v-for="progresso in progressoSemanalOrdenado"
                              :key="progresso.temaEstudoId"
                              class="mb-3 mb-sm-4 px-0"
                          >
                            <v-list-item-avatar :size="$vuetify.breakpoint.xs ? 36 : 48">
                              <v-avatar :color="progresso.corHex" :size="$vuetify.breakpoint.xs ? 36 : 48">
                                <v-icon color="white" :small="$vuetify.breakpoint.xs">mdi-book</v-icon>
                              </v-avatar>
                            </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title class="font-weight-medium text-body-2 text-sm-body-1 mb-1 mb-sm-2">
                                {{ progresso.temaEstudoNome }}
                              </v-list-item-title>
                              <v-progress-linear
                                  :value="calcularPercentualProgresso(progresso)"
                                  :color="progresso.corHex"
                                  :height="$vuetify.breakpoint.xs ? 18 : 24"
                                  rounded
                              >
                                <template v-slot:default>
                                  <strong class="white--text" :style="{ fontSize: $vuetify.breakpoint.xs ? '10px' : '12px' }">{{ calcularPercentualProgresso(progresso).toFixed(0) }}%</strong>
                                </template>
                              </v-progress-linear>
                              <v-list-item-subtitle class="text-caption mt-1">
                                {{ progresso.tempoEstudadoFormatado }} / {{ formatarHoras(progresso.horasSemanaisMeta) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-alert v-else type="info" text class="ma-2">
                          Nenhum progresso registrado nesta semana.
                        </v-alert>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- Resumo Semanal -->
                  <v-col cols="12" md="4" class="mb-3 mb-sm-4">
                    <v-card elevation="4" rounded="lg" outlined class="mb-3 mb-sm-4">
                      <v-card-title class="secondary white--text py-3 py-sm-4 px-3 px-sm-4">
                        <v-icon left color="white">mdi-chart-box</v-icon>
                        <span class="text-body-1 text-sm-h6">Resumo Semanal</span>
                      </v-card-title>
                      <v-card-text class="pa-4 pa-sm-6">
                        <v-row>
                          <v-col cols="6" md="12" class="text-center mb-0 mb-md-6">
                            <div class="text-h4 text-sm-display-1 primary--text font-weight-bold">
                              {{ calcularTotalHorasSemana() }}
                            </div>
                            <div class="text-caption text-sm-body-2 grey--text mt-1">Horas Estudadas</div>
                          </v-col>

                          <v-col cols="6" md="12" class="text-center">
                            <v-divider class="d-none d-md-block my-4"></v-divider>
                            <div class="text-h4 text-sm-h4 success--text font-weight-bold">
                              {{ calcularTemasComMetaAtingida() }}
                            </div>
                            <div class="text-caption text-sm-body-2 grey--text mt-1">Metas Atingidas</div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>

            <!-- TAB 4: HISTÓRICO -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <v-card-text class="pa-3 pa-sm-6">
                <!-- Filtros -->
                <v-card elevation="2" rounded="lg" class="mb-3 mb-sm-4">
                  <v-card-text class="pa-3 pa-sm-4">
                    <v-row dense>
                      <v-col cols="12" sm="4">
                        <v-select
                            v-model="filtroTemaId"
                            :items="[{id: null, nome: 'Todos os temas'}, ...temas]"
                            item-text="nome"
                            item-value="id"
                            label="Filtrar por Tema"
                            outlined
                            dense
                            clearable
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-select
                            v-model="filtroStatus"
                            :items="[
                            {text: 'Todos os status', value: null},
                            {text: 'Em Andamento', value: 'EM_ANDAMENTO'},
                            {text: 'Pausada', value: 'PAUSADA'},
                            {text: 'Finalizada', value: 'FINALIZADA'}
                          ]"
                            label="Status"
                            outlined
                            dense
                            clearable
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-menu
                            v-model="menuData"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="filtroData"
                                label="Data"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                              v-model="filtroData"
                              no-title
                              scrollable
                              locale="pt-BR"
                              @input="menuData = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

                <!-- Histórico -->
                <v-card elevation="4" rounded="lg" outlined>
                  <v-card-title class="primary white--text py-3 py-sm-4 px-3 px-sm-4">
                    <v-icon left color="white">mdi-history</v-icon>
                    <span class="text-body-1 text-sm-h6">Histórico de Sessões</span>
                    <v-spacer></v-spacer>
                    <v-btn icon color="white" @click="carregarHistoricoCompleto" :small="$vuetify.breakpoint.xs">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="pa-2 pa-sm-4" style="max-height: 550px; overflow-y: auto;">
                    <v-list v-if="historicoFiltrado.length > 0" class="pa-0">
                      <v-list-item
                          v-for="sessao in historicoFiltrado"
                          :key="sessao.id"
                          class="mb-2 rounded tema-item"
                          :class="$vuetify.breakpoint.xs ? 'px-2' : ''"
                          two-line
                      >
                        <v-list-item-avatar :size="$vuetify.breakpoint.xs ? 36 : 48">
                          <v-avatar :color="obterCorTema(sessao.temaEstudoId)" :size="$vuetify.breakpoint.xs ? 36 : 48">
                            <v-icon color="white" :small="$vuetify.breakpoint.xs">mdi-clock</v-icon>
                          </v-avatar>
                        </v-list-item-avatar>

                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium text-body-2 text-sm-body-1">
                            {{ obterNomeTema(sessao.temaEstudoId) }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="d-flex flex-wrap align-center mt-1" style="gap: 4px;">
                            <v-chip
                                x-small
                                :color="getStatusColor(sessao.status)"
                                dark
                            >
                              {{ formatarStatus(sessao.status) }}
                            </v-chip>
                            <span class="text-caption">{{ formatarSegundos(sessao.tempoEstudadoSegundos) }}</span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="text-caption">
                            {{ formatarDataHora(sessao.inicioSessao) }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle v-if="sessao.observacao" class="mt-1 text-caption">
                            <v-icon x-small>mdi-note-text</v-icon>
                            {{ sessao.observacao }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-alert v-else type="info" text class="ma-2">
                      Nenhuma sessão encontrada com os filtros atuais.
                    </v-alert>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-tab-item>

            <!-- TAB 5: FLASHCARDS -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <FlashcardsTab ref="flashcardsTab" />
            </v-tab-item>

            <!-- TAB 6: GAMIFICAÇÃO -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <GamificacaoTab ref="gamificacaoTab" />
            </v-tab-item>

            <!-- TAB 7: LAUCHECKS -->
            <v-tab-item :transition="tabsItemsTransition" :reverse-transition="tabsItemsTransition">
              <LauChecksTab ref="lauChecksTab" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de Confirmação de Deleção -->
    <v-dialog
        v-model="dialogDeletarTema"
        :max-width="$vuetify.breakpoint.xs ? '95%' : '450px'"
        :fullscreen="$vuetify.breakpoint.xs"
        class="responsive-dialog"
    >
      <v-card rounded="lg">
        <v-card-title class="error white--text py-3 py-sm-4 px-3 px-sm-4">
          <v-icon left color="white">mdi-alert</v-icon>
          Confirmar Deleção
        </v-card-title>
        <v-card-text class="pa-4 pa-sm-6">
          <p class="text-body-2 text-sm-body-1">Tem certeza que deseja deletar o tema <strong>{{ temaDeletar?.nome }}</strong>?</p>
          <p class="text-caption text-sm-body-2 grey--text">Esta ação irá desativar o tema, mas não apagará o histórico de sessões.</p>
        </v-card-text>
        <v-card-actions class="pa-3 pa-sm-4 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDeletarTema = false">Cancelar</v-btn>
          <v-btn color="error" @click="deletarTema" :loading="carregandoTema">Deletar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação de Cancelar Sessão -->
    <v-dialog
        v-model="dialogCancelarSessao"
        :max-width="$vuetify.breakpoint.xs ? '95%' : '450px'"
        :fullscreen="$vuetify.breakpoint.xs"
        class="responsive-dialog"
    >
      <v-card rounded="lg">
        <v-card-title class="warning white--text py-3 py-sm-4 px-3 px-sm-4">
          <v-icon left color="white">mdi-alert</v-icon>
          Confirmar Cancelamento
        </v-card-title>
        <v-card-text class="pa-4 pa-sm-6">
          <p class="text-body-2 text-sm-body-1">Tem certeza que deseja cancelar esta sessão?</p>
          <p class="text-caption text-sm-body-2 grey--text">A sessão será permanentemente removida e o tempo estudado não será contabilizado.</p>
        </v-card-text>
        <v-card-actions class="pa-3 pa-sm-4 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCancelarSessao = false">Não</v-btn>
          <v-btn color="warning" @click="cancelarSessao" :loading="carregandoSessao">Sim, Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Sessão Manual -->
    <v-dialog
        v-model="dialogSessaoManual"
        :max-width="$vuetify.breakpoint.xs ? '95%' : '600px'"
        :fullscreen="$vuetify.breakpoint.xs"
        persistent
        scrollable
        class="responsive-dialog"
    >
      <v-card rounded="lg">
        <v-card-title class="info white--text py-3 py-sm-4 px-3 px-sm-4">
          <v-icon left color="white" :size="$vuetify.breakpoint.smAndUp ? 28 : 22">mdi-pencil-plus</v-icon>
          <span class="text-body-1 text-sm-h6">Registrar Sessão Manual</span>
        </v-card-title>
        <v-card-text class="pa-3 pa-sm-6">
          <v-form ref="formSessaoManual" v-model="formSessaoManualValido">
            <v-select
                v-model="sessaoManual.temaEstudoId"
                :items="temasAtivos"
                item-text="nome"
                item-value="id"
                label="Selecione o Tema"
                outlined
                prepend-inner-icon="mdi-book"
                :rules="[v => !!v || 'Tema é obrigatório']"
                required
                class="mb-3"
                :dense="$vuetify.breakpoint.xs"
            >
              <template v-slot:item="{ item }">
                <v-list-item-avatar>
                  <v-avatar :color="item.corHex" size="40">
                    <v-icon color="white">mdi-book</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.nome }}</v-list-item-title>
                </v-list-item-content>
              </template>
            </v-select>

            <v-menu
                ref="menuDataSessao"
                v-model="menuDataSessao"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="sessaoManual.dataSessao"
                    label="Data da Sessão"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'Data é obrigatória']"
                    required
                    class="mb-3"
                    :dense="$vuetify.breakpoint.xs"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="sessaoManual.dataSessao"
                  @input="menuDataSessao = false"
                  :max="new Date().toISOString().substr(0, 10)"
                  locale="pt-BR"
              ></v-date-picker>
            </v-menu>

            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model.number="sessaoManual.horasEstudadas"
                    label="Horas"
                    type="number"
                    min="0"
                    outlined
                    prepend-inner-icon="mdi-clock-outline"
                    class="mb-3"
                    @input="garantirInteiroHorasManual"
                    :dense="$vuetify.breakpoint.xs"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                    v-model.number="sessaoManual.minutosEstudados"
                    label="Minutos"
                    type="number"
                    min="0"
                    max="59"
                    outlined
                    prepend-inner-icon="mdi-clock-outline"
                    class="mb-3"
                    @input="garantirInteiroMinutosManual"
                    :dense="$vuetify.breakpoint.xs"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-textarea
                v-model="sessaoManual.observacao"
                label="Observação (opcional)"
                outlined
                :rows="$vuetify.breakpoint.xs ? 2 : 3"
                prepend-inner-icon="mdi-note-text"
                class="mb-3"
                :dense="$vuetify.breakpoint.xs"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3 pa-sm-4 responsive-actions">
          <v-spacer></v-spacer>
          <v-btn text @click="fecharModalSessaoManual">Cancelar</v-btn>
          <v-btn
              color="info"
              @click="inserirSessaoManual"
              :loading="carregandoSessaoManual"
              :disabled="!podeInserirSessaoManual"
          >
            <v-icon left>mdi-content-save</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <StudyAiChat />
  </v-container>
</template>

<script>
import estudoService from '@/services/estudoService';
import GamificacaoTab from './tabs/GamificacaoTab.vue';
import FlashcardsTab from './tabs/FlashcardsTab.vue';
import LauChecksTab from './tabs/LauChecksTab.vue';
import SalaEstudos from './SalaEstudos.vue';
import StudyAiChat from './StudyAiChat.vue';

export default {
  name: 'EstudoPage',

  components: {
    GamificacaoTab,
    FlashcardsTab,
    LauChecksTab,
    SalaEstudos,
    StudyAiChat,
  },

  data() {
    return {
      grafico: null,
      tempoAtual: Date.now(),
      tabAtiva: this.$route?.path === '/estudar/lauschecks' ? 6 : 0,
      temas: [],
      temasAtivos: [],
      temaSelecionado: null,
      temaAtual: {
        nome: '',
        descricao: '',
        horas: 0,
        minutos: 30,
        corHex: '#2196F3',
        ativo: true
      },
      temaEditando: null,
      temaDeletar: null,
      sessaoAtiva: null,
      historicoCompleto: [],
      novaSessao: {
        temaEstudoId: null,
        observacao: ''
      },
      sessaoManual: {
        temaEstudoId: null,
        dataSessao: new Date().toISOString().substr(0, 10),
        horasEstudadas: 0,
        minutosEstudados: 0,
        observacao: ''
      },
      menuDataSessao: false,
      carregandoSessaoManual: false,
      formSessaoManualValido: false,
      dialogSessaoManual: false,
      dialogCancelarSessao: false,
      tempoDecorrido: 0,
      intervalTimer: null,
      progressoSemanal: [],
      semanaAtualSelecionada: new Date().toISOString().substr(0, 10),
      carregandoProgresso: false,
      filtroTemaId: null,
      filtroStatus: null,
      filtroData: null,
      menuData: false,
      carregandoTema: false,
      carregandoSessao: false,
      formTemaValido: false,
      formSessaoValido: false,
      dialogDeletarTema: false,
      infoSalaEstudos: null,
      intervalSalaEstudos: null,
      ultimoSyncSessaoAtiva: 0,
      ultimoRefreshTab: {},
      dadosIniciaisCarregados: false,
    };
  },

  computed: {
    isMobileViewport() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    tabsItemsTransition() {
      return this.isMobileViewport ? false : undefined;
    },

    tempoFormatado() {
      if (!this.sessaoAtiva) return '00:00:00';

      const progressoTema = this.progressoSemanal.find(p => p.temaEstudoId === this.sessaoAtiva.temaEstudoId);

      const segundosEmExecucao = this.calcularSegundosEmExecucao(this.sessaoAtiva);

      const sessaoTempoAtual = (this.sessaoAtiva.tempoEstudadoSegundos || 0) + segundosEmExecucao;

      if (!progressoTema) {
        return this.formatarSegundos(sessaoTempoAtual);
      }

      const metaSegundos = progressoTema.horasSemanaisMeta * 60;
      const totalEstudado = progressoTema.segundosEstudados + segundosEmExecucao;
      const tempoRestante = Math.max(0, metaSegundos - totalEstudado);

      return this.formatarSegundos(tempoRestante);
    },

    tempoSessaoAtual() {
      if (!this.sessaoAtiva) return '00:00:00';
      return this.formatarSegundos(this.sessaoAtiva.tempoEstudadoSegundos);
    },

    tempoSessaoVisual() {
      if (!this.sessaoAtiva) return '00:00:00';

      let segundos = this.sessaoAtiva.tempoEstudadoSegundos;

      segundos += this.calcularSegundosEmExecucao(this.sessaoAtiva);

      return this.formatarSegundos(segundos);
    },

    historicoFiltrado() {
      let historico = this.historicoCompleto;

      if (this.filtroTemaId) {
        historico = historico.filter(s => s.temaEstudoId === this.filtroTemaId);
      }

      if (this.filtroStatus) {
        historico = historico.filter(s => s.status === this.filtroStatus);
      }

      if (this.filtroData) {
        historico = historico.filter(s => {
          const dataSessao = new Date(s.inicioSessao).toISOString().split('T')[0];
          return dataSessao === this.filtroData;
        });
      }

      return historico;
    },

    podeInserirSessaoManual() {
      const horas = this.sessaoManual.horasEstudadas || 0;
      const minutos = this.sessaoManual.minutosEstudados || 0;
      const temTema = !!this.sessaoManual.temaEstudoId;
      const temData = !!this.sessaoManual.dataSessao;
      const temTempo = (horas > 0 || minutos > 0);

      return temTema && temData && temTempo;
    },

    temasOrdenados() {
      return [...this.temas].sort((a, b) => {
        if (a.ativo && !b.ativo) return -1;
        if (!a.ativo && b.ativo) return 1;
        return 0;
      });
    },

    progressoSemanalOrdenado() {
      return [...this.progressoSemanal].sort((a, b) => {
        const percA = this.calcularPercentualProgresso(a);
        const percB = this.calcularPercentualProgresso(b);
        return percB - percA;
      });
    },

    periodoSemanaAtual() {
      const data = new Date(this.semanaAtualSelecionada + 'T00:00:00');
      const diaSemana = data.getDay();

      const segunda = new Date(data);
      const diasParaSegunda = diaSemana === 0 ? -6 : 1 - diaSemana;
      segunda.setDate(data.getDate() + diasParaSegunda);

      const domingo = new Date(segunda);
      domingo.setDate(segunda.getDate() + 6);

      return { inicio: segunda, fim: domingo };
    },

    periodoSemanaFormatado() {
      const { inicio, fim } = this.periodoSemanaAtual;
      const opcoes = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const inicioStr = inicio.toLocaleDateString('pt-BR', opcoes);
      const fimStr = fim.toLocaleDateString('pt-BR', opcoes);
      return `${inicioStr} - ${fimStr}`;
    },

    ehSemanaAtual() {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      const { inicio, fim } = this.periodoSemanaAtual;
      return hoje >= inicio && hoje <= fim;
    }
  },

  async mounted() {
    this.sincronizarTabComRota();
    await this.verificarSessaoAtiva();

    if (this.tabAtiva !== 6) {
      await this.carregarDadosIniciais();
      await this.carregarInfoSalaEstudos();
    }

    this.iniciarTimerAtualizacao();
    if (this.tabAtiva === 0) {
      this.iniciarAtualizacaoSalaEstudos();
    }
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    window.addEventListener('focus', this.handleAppResume);
    window.addEventListener('pageshow', this.handleAppResume);
  },

  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    window.removeEventListener('focus', this.handleAppResume);
    window.removeEventListener('pageshow', this.handleAppResume);
    this.pararTimerAtualizacao();
    this.pararAtualizacaoSalaEstudos();
    if (this.grafico) this.grafico.destroy();
  },

  methods: {
    sincronizarTabComRota() {
      if (this.$route.path === '/estudar/lauschecks' && this.tabAtiva !== 6) {
        this.tabAtiva = 6;
      }
    },

    garantirInteiroHoras() {
      if (this.temaAtual.horas !== null && this.temaAtual.horas !== undefined) {
        this.temaAtual.horas = Math.max(0, Math.floor(Number(this.temaAtual.horas)));
      }
    },

    garantirInteiroMinutos() {
      if (this.temaAtual.minutos !== null && this.temaAtual.minutos !== undefined) {
        let minutos = Math.max(0, Math.floor(Number(this.temaAtual.minutos)));
        if (minutos > 59) minutos = 59;
        this.temaAtual.minutos = minutos;
      }
    },

    formatarTempoTotal(horas, minutos) {
      const h = horas || 0;
      const m = minutos || 0;
      if (h === 0 && m === 0) return '0 min';
      if (h === 0) return `${m} min`;
      if (m === 0) return `${h}h`;
      return `${h}h ${m}min`;
    },

    formatarTempoMeta(tema) {
      if (tema.minutosSemanaisTotais !== undefined) {
        const totalMinutos = tema.minutosSemanaisTotais;
        const horas = Math.floor(totalMinutos / 60);
        const minutos = totalMinutos % 60;
        return this.formatarTempoTotal(horas, minutos);
      } else if (tema.horas !== undefined && tema.minutos !== undefined) {
        return this.formatarTempoTotal(tema.horas, tema.minutos);
      } else if (tema.horasSemanais !== undefined) {
        const totalMinutos = tema.horasSemanais;
        const horas = Math.floor(totalMinutos / 60);
        const minutos = totalMinutos % 60;
        return this.formatarTempoTotal(horas, minutos);
      }
      return '0 min';
    },

    prepararDadosTema(tema) {
      const horas = tema.horas || 0;
      const minutos = tema.minutos || 0;
      const minutosSemanaisTotais = (horas * 60) + minutos;
      // eslint-disable-next-line no-unused-vars
      const { horas: _, minutos: __, horasSemanais: ___, ...temaLimpo } = tema;
      return { ...temaLimpo, minutosSemanaisTotais };
    },

    converterResponseParaForm(tema) {
      if (tema.minutosSemanaisTotais !== undefined) {
        const totalMinutos = tema.minutosSemanaisTotais;
        return { ...tema, horas: Math.floor(totalMinutos / 60), minutos: totalMinutos % 60 };
      } else if (tema.horas !== undefined && tema.minutos !== undefined) {
        return { ...tema, horas: tema.horas || 0, minutos: tema.minutos || 0 };
      } else if (tema.horasSemanais !== undefined) {
        const totalMinutos = tema.horasSemanais;
        return { ...tema, horas: Math.floor(totalMinutos / 60), minutos: totalMinutos % 60 };
      }
      return tema;
    },

    async carregarDadosIniciais() {
      try {
        await Promise.all([
          this.carregarTemas(),
          this.carregarProgressoSemanal(),
          this.carregarHistoricoCompleto()
        ]);
        this.dadosIniciaisCarregados = true;
      } catch (error) {
        console.error('Erro ao carregar dados iniciais:', error);
        this.$toast.error('Erro ao carregar dados');
      }
    },

    async carregarTemas() {
      try {
        this.temas = await estudoService.listarTemas();
        this.temasAtivos = await estudoService.listarTemasAtivos();
      } catch (error) {
        console.error('Erro ao carregar temas:', error);
        this.$toast.error('Erro ao carregar temas');
      }
    },

    async criarTema() {
      const horas = this.temaAtual.horas || 0;
      const minutos = this.temaAtual.minutos || 0;

      if (!this.temaAtual.nome) {
        this.$toast.error('Nome do tema é obrigatório');
        return;
      }

      if (horas === 0 && minutos === 0) {
        this.$toast.error('A meta semanal deve ser maior que 0');
        return;
      }

      this.carregandoTema = true;
      try {
        const dadosTema = this.prepararDadosTema(this.temaAtual);
        await estudoService.criarTema(dadosTema);
        this.$toast.success('Tema criado com sucesso!');
        this.temaAtual = { nome: '', descricao: '', horas: 0, minutos: 30, corHex: '#2196F3', ativo: true };
        await this.carregarTemas();
      } catch (error) {
        console.error('Erro ao criar tema:', error);
        this.$toast.error('Erro ao criar tema');
      } finally {
        this.carregandoTema = false;
      }
    },

    iniciarEdicaoTema(tema) {
      this.temaEditando = tema;
      this.temaAtual = this.converterResponseParaForm({...tema});
      this.tabAtiva = 1;
    },

    async salvarEdicaoTema() {
      const horas = this.temaAtual.horas || 0;
      const minutos = this.temaAtual.minutos || 0;

      if (!this.temaAtual.nome) {
        this.$toast.error('Nome do tema é obrigatório');
        return;
      }

      if (horas === 0 && minutos === 0) {
        this.$toast.error('A meta semanal deve ser maior que 0');
        return;
      }

      this.carregandoTema = true;
      try {
        const dadosTema = this.prepararDadosTema(this.temaAtual);
        await estudoService.atualizarTema(this.temaEditando.id, dadosTema);
        this.$toast.success('Tema atualizado com sucesso!');
        this.cancelarEdicao();
        await this.carregarTemas();
      } catch (error) {
        console.error('Erro ao atualizar tema:', error);
        this.$toast.error('Erro ao atualizar tema');
      } finally {
        this.carregandoTema = false;
      }
    },

    cancelarEdicao() {
      this.temaEditando = null;
      this.temaAtual = { nome: '', descricao: '', horas: 0, minutos: 30, corHex: '#2196F3', ativo: true };
    },

    async ativarTema(tema) {
      try {
        const dadosTema = this.prepararDadosTema({...tema, ativo: true});
        await estudoService.atualizarTema(tema.id, dadosTema);
        this.$toast.success('Tema ativado com sucesso!');
        await this.carregarTemas();
      } catch (error) {
        this.$toast.error('Erro ao ativar tema');
      }
    },

    async desativarTema(tema) {
      try {
        const dadosTema = this.prepararDadosTema({...tema, ativo: false});
        await estudoService.atualizarTema(tema.id, dadosTema);
        this.$toast.success('Tema desativado com sucesso!');
        await this.carregarTemas();
      } catch (error) {
        this.$toast.error('Erro ao desativar tema');
      }
    },

    confirmarDeletarTema(tema) {
      this.temaDeletar = tema;
      this.dialogDeletarTema = true;
    },

    async deletarTema() {
      this.carregandoTema = true;
      try {
        await estudoService.deletarTema(this.temaDeletar.id);
        this.$toast.success('Tema deletado com sucesso!');
        this.dialogDeletarTema = false;
        this.temaDeletar = null;
        await this.carregarTemas();
      } catch (error) {
        this.$toast.error('Erro ao deletar tema');
      } finally {
        this.carregandoTema = false;
      }
    },

    selecionarTemaControle(tema) {
      this.novaSessao.temaEstudoId = tema.id;
    },

    async verificarSessaoAtiva({ preservarAtualSeNaoEncontrar = false } = {}) {
      try {
        const temas = await estudoService.listarTemasAtivos();
        let sessaoEncontrada = null;

        for (const tema of temas) {
          const sessoes = await estudoService.listarSessoesTema(tema.id);
          const sessaoEmAndamento = sessoes.find(s => s.status === 'EM_ANDAMENTO' || s.status === 'PAUSADA');
          if (sessaoEmAndamento) {
            sessaoEncontrada = { sessao: sessaoEmAndamento, tema };
            break;
          }
        }

        if (sessaoEncontrada) {
          this.sessaoAtiva = this.montarSessaoAtiva(sessaoEncontrada.sessao, sessaoEncontrada.tema);
        } else if (!preservarAtualSeNaoEncontrar) {
          this.sessaoAtiva = null;
        }
      } catch (error) {
        console.error('Erro ao verificar sessão ativa:', error);
      }
    },

    montarSessaoAtiva(sessao, tema, sessaoAnterior = this.sessaoAtiva) {
      const ultimoInicio = this.resolverUltimoInicioSessao(sessao);

      return {
        ...sessao,
        temaNome: tema?.nome || sessaoAnterior?.temaNome,
        temaCorHex: tema?.corHex || sessaoAnterior?.temaCorHex,
        temaEstudoId: tema?.id || sessao.temaEstudoId || sessaoAnterior?.temaEstudoId,
        ultimoInicio
      };
    },

    resolverUltimoInicioSessao(sessao) {
      if (sessao.status !== 'EM_ANDAMENTO') {
        return sessao.ultimoInicio || null;
      }

      return new Date().toISOString();
    },

    calcularSegundosEmExecucao(sessao) {
      if (!sessao || sessao.status !== 'EM_ANDAMENTO' || !sessao.ultimoInicio) {
        return 0;
      }

      const inicio = new Date(sessao.ultimoInicio).getTime();
      if (Number.isNaN(inicio)) return 0;

      return Math.max(0, Math.floor((this.tempoAtual - inicio) / 1000));
    },

    async iniciarSessao() {
      if (!this.novaSessao.temaEstudoId) {
        this.$toast.error('Selecione um tema');
        return;
      }

      this.carregandoSessao = true;
      try {
        const sessao = await estudoService.iniciarSessao(this.novaSessao.temaEstudoId, this.novaSessao.observacao);
        const tema = this.temasAtivos.find(t => t.id === this.novaSessao.temaEstudoId);
        this.sessaoAtiva = this.montarSessaoAtiva(sessao, tema);

        await this.carregarProgressoSemanal();
        this.atualizarSalaEstudos();
        this.$toast.success('Sessão iniciada! Bons estudos!');
        this.novaSessao = { temaEstudoId: null, observacao: '' };
        this.tocarSom('iniciar');
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erro ao iniciar sessão');
      } finally {
        this.carregandoSessao = false;
      }
    },

    async pausarSessao() {
      this.carregandoSessao = true;
      try {
        const sessaoAtualizada = await estudoService.pausarSessao(this.sessaoAtiva.id);
        await this.carregarProgressoSemanal();
        this.sessaoAtiva = this.montarSessaoAtiva(sessaoAtualizada, null);
        this.$toast.info('Sessão pausada');
      } catch (error) {
        this.$toast.error('Erro ao pausar sessão');
      } finally {
        this.carregandoSessao = false;
      }
    },

    async retomarSessao() {
      this.carregandoSessao = true;
      try {
        const sessaoAtualizada = await estudoService.retomarSessao(this.sessaoAtiva.id);
        await this.carregarProgressoSemanal();
        this.sessaoAtiva = this.montarSessaoAtiva(sessaoAtualizada, null);
        this.$toast.success('Sessão retomada!');
      } catch (error) {
        this.$toast.error('Erro ao retomar sessão');
      } finally {
        this.carregandoSessao = false;
      }
    },

    async finalizarSessao() {
      this.carregandoSessao = true;
      try {
        await estudoService.finalizarSessao(this.sessaoAtiva.id);
        this.$toast.success('Sessão finalizada! Parabéns pelo esforço!');
        this.sessaoAtiva = null;
        await this.carregarProgressoSemanal();
        await this.carregarHistoricoCompleto();
        this.atualizarSalaEstudos();
        this.tocarSom('finalizar');
      } catch (error) {
        this.$toast.error('Erro ao finalizar sessão');
      } finally {
        this.carregandoSessao = false;
      }
    },

    confirmarCancelarSessao() {
      this.dialogCancelarSessao = true;
    },

    async cancelarSessao() {
      this.carregandoSessao = true;
      try {
        await estudoService.cancelarSessao(this.sessaoAtiva.id);
        this.$toast.success('Sessão cancelada com sucesso');
        this.sessaoAtiva = null;
        this.dialogCancelarSessao = false;
        await this.carregarProgressoSemanal();
        await this.carregarHistoricoCompleto();
        this.atualizarSalaEstudos();
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erro ao cancelar sessão');
      } finally {
        this.carregandoSessao = false;
      }
    },

    garantirInteiroHorasManual() {
      if (this.sessaoManual.horasEstudadas !== null && this.sessaoManual.horasEstudadas !== undefined) {
        this.sessaoManual.horasEstudadas = Math.max(0, Math.floor(Number(this.sessaoManual.horasEstudadas)));
      }
    },

    garantirInteiroMinutosManual() {
      if (this.sessaoManual.minutosEstudados !== null && this.sessaoManual.minutosEstudados !== undefined) {
        let minutos = Math.max(0, Math.floor(Number(this.sessaoManual.minutosEstudados)));
        if (minutos > 59) minutos = 59;
        this.sessaoManual.minutosEstudados = minutos;
      }
    },

    fecharModalSessaoManual() {
      this.dialogSessaoManual = false;
      this.sessaoManual = {
        temaEstudoId: null,
        dataSessao: new Date().toISOString().substr(0, 10),
        horasEstudadas: 0,
        minutosEstudados: 0,
        observacao: ''
      };
    },

    async inserirSessaoManual() {
      const horas = this.sessaoManual.horasEstudadas || 0;
      const minutos = this.sessaoManual.minutosEstudados || 0;

      if (!this.sessaoManual.temaEstudoId) { this.$toast.error('Selecione um tema'); return; }
      if (!this.sessaoManual.dataSessao) { this.$toast.error('Selecione uma data'); return; }
      if (horas === 0 && minutos === 0) { this.$toast.error('Informe o tempo estudado'); return; }

      this.carregandoSessaoManual = true;
      try {
        await estudoService.inserirSessaoManual({
          temaEstudoId: this.sessaoManual.temaEstudoId,
          dataSessao: this.sessaoManual.dataSessao,
          horasEstudadas: horas,
          minutosEstudados: minutos,
          observacao: this.sessaoManual.observacao
        });
        this.$toast.success('Sessão manual registrada com sucesso!');
        this.fecharModalSessaoManual();
        await this.carregarProgressoSemanal();
        await this.carregarHistoricoCompleto();
      } catch (error) {
        this.$toast.error(error.response?.data?.message || 'Erro ao inserir sessão manual');
      } finally {
        this.carregandoSessaoManual = false;
      }
    },

    async carregarProgressoSemanal() {
      try {
        this.carregandoProgresso = true;

        if (this.ehSemanaAtual) {
          this.progressoSemanal = await estudoService.obterProgressoSemanal();
        } else {
          this.progressoSemanal = await estudoService.obterProgressoSemanalPorData(this.semanaAtualSelecionada);
        }

        this.$nextTick(() => {
          this.criarGraficoEvolucao();
        });
      } catch (error) {
        console.error('Erro ao carregar progresso semanal:', error);
        this.$toast.error('Erro ao carregar progresso semanal');
      } finally {
        this.carregandoProgresso = false;
      }
    },

    calcularProgressoTema(temaId) {
      const progresso = this.progressoSemanal.find(p => p.temaEstudoId === temaId);
      if (!progresso) return 0;
      const metaEmSegundos = progresso.horasSemanaisMeta * 60;
      const percentual = (progresso.segundosEstudados / metaEmSegundos) * 100;
      return Math.min(percentual, 100).toFixed(0);
    },

    calcularPercentualProgresso(progresso) {
      const metaEmSegundos = progresso.horasSemanaisMeta * 60;
      const percentual = (progresso.segundosEstudados / metaEmSegundos) * 100;
      return Math.min(percentual, 100);
    },

    calcularTotalHorasSemana() {
      if (!this.progressoSemanal.length) return '0h';
      const totalSegundos = this.progressoSemanal.reduce((acc, p) => acc + p.segundosEstudados, 0);
      const horas = Math.floor(totalSegundos / 3600);
      const minutos = Math.floor((totalSegundos % 3600) / 60);
      return minutos > 0 ? `${horas}h ${minutos}min` : `${horas}h`;
    },

    calcularTemasComMetaAtingida() {
      return this.progressoSemanal.filter(p => this.calcularPercentualProgresso(p) >= 100).length;
    },

    async carregarHistoricoCompleto() {
      try {
        const todasSessoes = [];
        for (const tema of this.temas) {
          const sessoes = await estudoService.listarSessoesTema(tema.id);
          todasSessoes.push(...sessoes);
        }
        this.historicoCompleto = todasSessoes.sort((a, b) => new Date(b.inicioSessao) - new Date(a.inicioSessao));
      } catch (error) {
        this.$toast.error('Erro ao carregar histórico');
      }
    },

    obterNomeTema(temaId) {
      const tema = this.temas.find(t => t.id === temaId);
      return tema ? tema.nome : 'Tema não encontrado';
    },

    obterCorTema(temaId) {
      const tema = this.temas.find(t => t.id === temaId);
      return tema ? tema.corHex : '#9E9E9E';
    },

    semanaAnterior() {
      const data = new Date(this.semanaAtualSelecionada + 'T00:00:00');
      data.setDate(data.getDate() - 7);
      this.semanaAtualSelecionada = data.toISOString().substr(0, 10);
      this.carregarProgressoSemanal();
    },

    proximaSemana() {
      const data = new Date(this.semanaAtualSelecionada + 'T00:00:00');
      data.setDate(data.getDate() + 7);
      const hoje = new Date();
      const novaData = new Date(data);
      novaData.setHours(0, 0, 0, 0);
      if (novaData > hoje) {
        this.$toast.warning('Não é possível visualizar semanas futuras');
        return;
      }
      this.semanaAtualSelecionada = data.toISOString().substr(0, 10);
      this.carregarProgressoSemanal();
    },

    voltarParaSemanaAtual() {
      this.semanaAtualSelecionada = new Date().toISOString().substr(0, 10);
      this.carregarProgressoSemanal();
    },

    isDocumentHidden() {
      return typeof document !== 'undefined' && document.hidden;
    },

    iniciarTimerAtualizacao() {
      this.pararTimerAtualizacao();
      if (this.isDocumentHidden()) return;

      this.sincronizarRelogioAgora();
      this.intervalTimer = setInterval(() => {
        if (this.isDocumentHidden()) return;
        this.sincronizarRelogioAgora();
      }, 1000);
    },

    pararTimerAtualizacao() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
        this.intervalTimer = null;
      }
    },

    sincronizarRelogioAgora() {
      this.tempoAtual = Date.now();
    },

    formatarSegundos(segundos) {
      const horas = Math.floor(segundos / 3600);
      const minutos = Math.floor((segundos % 3600) / 60);
      const segs = segundos % 60;
      return `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}:${String(segs).padStart(2, '0')}`;
    },

    formatarHoras(minutosTotais) {
      const h = Math.floor(minutosTotais / 60);
      const m = minutosTotais % 60;
      if (h === 0 && m === 0) return '0 min';
      if (h === 0) return `${m}min`;
      if (m === 0) return `${h}h`;
      return `${h}h ${m}min`;
    },

    formatarDataHora(dataHora) {
      if (!dataHora) return '';
      const data = new Date(dataHora);
      return data.toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      });
    },

    formatarStatus(status) {
      const statusMap = {
        'EM_ANDAMENTO': 'Em Andamento',
        'PAUSADA': 'Pausada',
        'FINALIZADA': 'Finalizada'
      };
      return statusMap[status] || status;
    },

    getStatusColor(status) {
      const cores = { 'EM_ANDAMENTO': 'success', 'PAUSADA': 'warning', 'FINALIZADA': 'info' };
      return cores[status] || 'grey';
    },

    tocarSom(tipo) {
      try {
        const audio = new Audio(`/sons/${tipo}.mp3`);
        audio.play().catch(err => console.log('Erro ao tocar som:', err));
      } catch (error) {
        console.log('Som não disponível');
      }
    },

    atualizarSalaEstudos() {
      if (this.$refs.salaEstudos) this.$refs.salaEstudos.refresh();
      this.carregarInfoSalaEstudos();
    },

    async carregarInfoSalaEstudos() {
      try {
        this.infoSalaEstudos = await estudoService.obterSalaEstudos();
      } catch (error) {
        console.error('Erro ao carregar informações da sala de estudos:', error);
      }
    },

    iniciarAtualizacaoSalaEstudos() {
      this.pararAtualizacaoSalaEstudos();
      if (this.isDocumentHidden()) return;

      this.intervalSalaEstudos = setInterval(() => {
        if (this.isDocumentHidden()) return;
        this.carregarInfoSalaEstudos();
      }, 30000);
    },

    pararAtualizacaoSalaEstudos() {
      if (this.intervalSalaEstudos) {
        clearInterval(this.intervalSalaEstudos);
        this.intervalSalaEstudos = null;
      }
    },

    handleVisibilityChange() {
      if (this.isDocumentHidden()) {
        this.pararTimerAtualizacao();
        this.pararAtualizacaoSalaEstudos();
        return;
      }

      this.handleAppResume();
    },

    handleAppResume() {
      if (this.isDocumentHidden()) return;

      this.sincronizarRelogioAgora();
      this.iniciarTimerAtualizacao();
      if (this.tabAtiva === 0) {
        this.iniciarAtualizacaoSalaEstudos();
      }

      this.sincronizarSessaoAtivaAposRetorno();

      if (this.tabAtiva === 0) {
        this.carregarInfoSalaEstudos();
      }
    },

    async sincronizarSessaoAtivaAposRetorno() {
      if (!this.sessaoAtiva || this.carregandoSessao) return;

      const agora = Date.now();
      if (agora - this.ultimoSyncSessaoAtiva < 5000) return;
      this.ultimoSyncSessaoAtiva = agora;

      await this.verificarSessaoAtiva({ preservarAtualSeNaoEncontrar: true });
      await this.carregarProgressoSemanal();
      this.sincronizarRelogioAgora();
    },

    deveAtualizarTab(tab) {
      if (this.isDocumentHidden()) return false;

      const agora = Date.now();
      const ultimoRefresh = this.ultimoRefreshTab[tab] || 0;
      if (agora - ultimoRefresh < 5000) return false;

      this.$set(this.ultimoRefreshTab, tab, agora);
      return true;
    },
  },

  watch: {
    tabAtiva(novaTab) {
      if (novaTab !== 6 && !this.dadosIniciaisCarregados) {
        this.carregarDadosIniciais();
      }
      if (novaTab === 0) {
        this.carregarInfoSalaEstudos();
        this.iniciarAtualizacaoSalaEstudos();
      } else {
        this.pararAtualizacaoSalaEstudos();
      }
      if (novaTab === 5 && this.$refs.gamificacaoTab && this.deveAtualizarTab(novaTab)) {
        this.$nextTick(() => {
          this.$refs.gamificacaoTab.refreshDados();
        });
      }
      if (novaTab === 6 && this.$refs.lauChecksTab && this.deveAtualizarTab(novaTab)) {
        this.$nextTick(() => {
          this.$refs.lauChecksTab.refreshDados();
        });
      }
      if (novaTab === 6 && this.$route.path !== '/estudar/lauschecks') {
        this.$router.push('/estudar/lauschecks').catch(() => {});
      } else if (novaTab !== 6 && this.$route.path === '/estudar/lauschecks') {
        this.$router.push('/estudar').catch(() => {});
      }
    },

    '$route.path'() {
      this.sincronizarTabComRota();
    }
  }
};
</script>

<style scoped>
.background-gradient {
  background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
}

.page-card {
  border-radius: 16px !important;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.07) !important;
}

.sessao-card {
  min-height: 380px;
  transition: all 0.3s ease;
}

/* Cronômetro responsivo */
.cronometro-display {
  font-size: clamp(36px, 8vw, 60px);
  line-height: 1.1;
}

.tema-item {
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.tema-item:hover {
  background-color: rgba(0, 0, 0, 0.02);
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* Tabs responsivos - apenas ícones no mobile */
.tab-item {
  min-width: unset !important;
  padding: 0 8px !important;
}

.responsive-actions {
  flex-wrap: wrap;
  gap: 8px;
}

.responsive-actions .v-btn {
  margin-left: 0 !important;
}

@media (min-width: 600px) {
  .tab-item {
    min-width: 120px !important;
    padding: 0 16px !important;
  }

  .sessao-card {
    min-height: 450px;
  }
}

.v-btn {
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.2s ease;
}

/* Desativa hover transform no mobile (touch) */
@media (hover: hover) {
  .v-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  .page-card:hover {
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1) !important;
  }
}

::v-deep .v-tabs-slider {
  height: 3px;
}

::v-deep .v-tab {
  letter-spacing: 0.5px;
  text-transform: none;
  font-weight: 500;
}

::v-deep .v-progress-linear {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Scrollbar personalizada apenas em desktop */
@media (min-width: 600px) {
  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 10px; }
  ::-webkit-scrollbar-thumb { background: #888; border-radius: 10px; }
  ::-webkit-scrollbar-thumb:hover { background: #555; }
}

/* Dialog full-width no mobile */
@media (max-width: 599px) {
  .background-gradient {
    min-height: 100vh;
  }

  .page-card {
    border-radius: 10px !important;
    transition: box-shadow 0.15s ease, background-color 0.15s ease !important;
  }

  .estudo-tabs-card {
    overflow: hidden;
  }

  .study-tabs {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .tab-item {
    min-width: 56px !important;
    max-width: 72px;
    padding: 0 6px !important;
  }

  .sessao-card {
    min-height: auto;
    transition: none !important;
  }

  .tema-item,
  .v-btn {
    transition: background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease !important;
  }

  .cronometro-display {
    font-size: clamp(34px, 14vw, 48px);
    overflow-wrap: anywhere;
  }

  ::v-deep .v-window__container,
  ::v-deep .v-window-item {
    transition: none !important;
  }

  ::v-deep .v-progress-linear {
    box-shadow: none;
  }

  ::v-deep .v-dialog {
    margin: 8px !important;
    max-height: calc(100% - 16px) !important;
  }

  ::v-deep .v-dialog--fullscreen {
    margin: 0 !important;
    border-radius: 0 !important;
    max-height: 100% !important;
  }

  ::v-deep .v-dialog:not(.v-dialog--fullscreen) > .v-card,
  ::v-deep .v-dialog--fullscreen > .v-card {
    display: flex;
    flex-direction: column;
    max-height: 100vh;
  }

  ::v-deep .v-dialog .v-card__text {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  ::v-deep .v-card__title {
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    line-height: 1.25;
    word-break: break-word;
  }

  ::v-deep .v-list-item__action {
    align-self: flex-start;
    margin-left: 4px !important;
  }

  ::v-deep .v-list-item {
    padding: 0 8px !important;
    min-height: auto !important;
  }

  ::v-deep .v-list-item__content {
    min-width: 0;
  }

  ::v-deep .v-list-item__title,
  ::v-deep .v-list-item__subtitle {
    overflow: visible;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }

  ::v-deep .v-chip {
    max-width: 100%;
  }

  ::v-deep .v-chip .v-chip__content {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ::v-deep .v-picker {
    width: 100%;
    max-width: 100%;
  }

  .responsive-actions {
    justify-content: stretch;
  }

  .responsive-actions .v-btn {
    flex: 1 1 100%;
  }

  .responsive-actions .spacer {
    display: none;
  }
}
</style>
